// extracted by mini-css-extract-plugin
module.exports = {"button":"_1s9sEhp","icon":"_2RPLnKp"};